webpackJsonp([212839066777427],{

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _colors = __webpack_require__(8);
	
	__webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "blog__BlogWrapper"
	})(["display:flex;flex-direction:column;align-items:center;padding:100px 0px 100px 0px;width:100%;background-color:", ";a{color:", ";transition:all 200ms ease;}:hover{transform:translateY(-3px);}"], _colors.TINY_BKG, _colors.PRIMARY_TEXT);
	
	var BlogPostPreview = _styledComponents2.default.div.withConfig({
	  displayName: "blog__BlogPostPreview"
	})(["display:flex;position:relative;z-index:3;flex-direction:column;align-items:flex-start;max-width:750px;margin:50px 0px;padding:50px;border-radius:8px;background-color:white;box-shadow:0px 4px 10px ", ";transition:all 400ms ease;h3{font-weight:400;}h1{margin-bottom:25px;}:hover{transform:translateY(-3px);box-shadow:0px 6px 15px ", ";}@media screen and (max-width:768px){width:80%;margin:25px 0px;}@media screen and (max-width:615px){width:90%;margin:10px 0px;}"], _colors.TINY_SHADOW, _colors.TINY_SHADOW);
	var BlogPostInfo = _styledComponents2.default.div.withConfig({
	  displayName: "blog__BlogPostInfo"
	})(["display:flex;justify-content:space-between;width:100%;margin-bottom:50px;p{color ", ";}"], _colors.ACTIVE_TEXT);
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    BlogWrapper,
	    null,
	    posts.filter(function (post) {
	      return post.node.frontmatter.title.length > 0;
	    }).map(function (_ref2) {
	      var post = _ref2.node;
	
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: post.frontmatter.path },
	        _react2.default.createElement(
	          BlogPostPreview,
	          null,
	          _react2.default.createElement(
	            BlogPostInfo,
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              post.frontmatter.title
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              post.frontmatter.date
	            )
	          ),
	          _react2.default.createElement(
	            "h3",
	            null,
	            post.frontmatter.postGreeting
	          ),
	          _react2.default.createElement(
	            "h1",
	            null,
	            post.frontmatter.postTitle
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            post.frontmatter.postPreview
	          )
	        )
	      );
	    })
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-e6f444a4a58c76c1ec77.js